export default "__VITE_ASSET__BXXdq4v9__"